// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mAE1fP1UHSjjRVzcNPvt{margin-bottom:20px}", "",{"version":3,"sources":["webpack://./src/code-studio/components/progress/announcements.module.scss"],"names":[],"mappings":"AAAA,sBACE,kBAAA","sourcesContent":[".notificationBanner {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationBanner": "mAE1fP1UHSjjRVzcNPvt"
};
export default ___CSS_LOADER_EXPORT___;
